import { useState } from "react";
import { IDataResult, ResponseStatus } from "../../common/models/Result";
import { DataUtils } from "../../common/views/DataUtils";
import { Utils } from "../../common/views/Utils";
import { PopularSearchModel } from "../../websites/models/PopularSearchModel";
import { PopularSearchService } from "../../websites/services/PopularSearchService";

export function usePopularSearchVM() {
    const service = new PopularSearchService();

    const [originalList, setOriginalList] = useState<PopularSearchModel[]>([]);
    const [list, setList] = useState<PopularSearchModel[]>([]);
    const [listHash, setListHash] = useState<number>(0);

    const [selectedText, setSelectedText] = useState<PopularSearchModel | null>(null);
    const [showWebsites, setShowWebsites] = useState(false);

    const [showAll, setShowAll] = useState(false);
    const [filterText, setFilterText] = useState<string>("");
    const [sortByName, setSortByName] = useState<boolean>(false);

    const getList = (count: number) => {
        setOriginalList([]);

        const onResult = (result: IDataResult) => {
            if (result.status === ResponseStatus.success) {
                setOriginalList(result.data);
                generateNewWebsites(result.data, sortByName);
            }
        }

        DataUtils.onRequest(service.getOpenList(count), onResult);
    }

    const onSort = (sortByName: boolean) => {
        setSortByName(sortByName);
        generateNewWebsites(originalList, sortByName);
    }

    const generateNewWebsites = (list: PopularSearchModel[], sortByName: boolean) => {
        const lowfilterText = filterText.toLowerCase();

        if (!Utils.isNullOrEmpty(filterText)) {
            list = list.filter((item) => item.text.toLowerCase().includes(lowfilterText));
        }

        if (sortByName) {
            list = list.sort((a, b) => a.text.localeCompare(b.text));
        } else {
            list = list.sort((a, b) => b.popularity - a.popularity);
        }

        setList(list);
        setListHash(Utils.getRandomKey());
    }

    return {
        list,
        listHash,
        selectedText, setSelectedText,
        showWebsites, setShowWebsites,
        showAll, setShowAll,
        filterText, setFilterText,
        sortByName, setSortByName,
        getList,
        onSort
    }
}